export default __webpack_public_path__ + "static/media/a2.7fde5628.png";